export enum LocationValidationStatus {
    OK = "OK",
    NOT_FOUND = "NOT_FOUND",
    VARIATION_FOUND = "VARIATION_FOUND"
}